import { useContext } from 'react';
import { store } from '../store';

const usePlayerSelector = (isAlias) => {
    const { state: { user, team, playerRmb } } = useContext(store);

    let player;
    if (isAlias === true) player = user?.alias;
    else if (isAlias === false) player = user?.player;
    else player = user?.player || user?.alias;

    // pull team from context, if present,
    // override player.Team/player.TeamID
    if (player && team?.TeamID) {
        player.Team = team;
        player.TeamID = team.TeamID;
        player.LevelID = team.LevelID;
    }

    return {
        ...player,
        IsCatcher: player?.Position === 2 || player?.PrimaryPosition === 2 || playerRmb?.IsRmbCatcher,
        IsMlbOrAAA: player?.LevelID === 8 || player?.LevelID === 1,
        IsMlb: player?.LevelID === 8,
    };
};

export default usePlayerSelector;
